import { Select } from "./Select";
import { toMap } from "../../../../../HA";

export class MultiText extends Select {

    public replaceItems(items: any[]) {
        this.getEntries().replaceItems(items);
        const t = this.findByAttribute("counter");
        t.setText(items.length);
    }

    public getType(): string {
        return "MultiText";
    }

    public getChoices(): Map<any, any> {
        const r = new Map();
        const choices = this.getSelected();

        if (choices) {
            choices.forEach((c: any) => {
                r.set(c, toMap({v: c, s: this.isSelected(c)}));
            });
        }

        return r;
    }

    protected getChoicesLength() {
        return 0;
    }

    protected isSelected(value: any) {
        return true;
    }
}
